import axios from 'axios';
import { history } from './history';

const http = axios.create({
    baseURL: 'https://petromah.sabinarya.com/service/api/',
    headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
    }
})

http.interceptors.response.use(response => response,error => {
    if(error.response.status != 400 && error.response.status != 500 && error.response.status != 404){
        localStorage.removeItem('token');
        localStorage.removeItem('businessId');
        localStorage.removeItem('rl');
        localStorage.removeItem('user');
        history.navigate('/login');
    }
})

export default {
    get: http.get,
    post: http.post,
    put: http.put,
    delete: http.delete,
}

